import React from "react";
import { CustomTypography } from "src/components/ui";

const Dashboard: React.FC = () => {
  return (
    <div className="p-8">
      <CustomTypography.CustomTitle level={2}>Dashboard</CustomTypography.CustomTitle>
      <CustomTypography.CustomParagraph>
        Welcome to your TypeScript React Boilerplate Dashboard!
      </CustomTypography.CustomParagraph>
    </div>
  );
};

export default Dashboard;
